// extracted by mini-css-extract-plugin
export default {"terms":"TermsAndCondition_terms__Uy77v","index":"TermsAndCondition_index__-Q9T4","letterList":"TermsAndCondition_letterList__khsWV"};